import { render, staticRenderFns } from "./MemoBadgesLayer.vue?vue&type=template&id=61c0352a&scoped=true&"
import script from "./MemoBadgesLayer.vue?vue&type=script&lang=js&"
export * from "./MemoBadgesLayer.vue?vue&type=script&lang=js&"
import style0 from "./MemoBadgesLayer.vue?vue&type=style&index=0&id=61c0352a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0352a",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions})
